import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "@phosphor-icons/react";
import { Logo } from "./Logo";

export const LegalLayout = ({ overline, title, lastUpdated, children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0E] text-[#F5F2E8]" data-testid="legal-page">
      {/* Minimal header */}
      <header className="border-b border-white/5 bg-[#0B0B0E]/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link">
            <Logo size={44} />
          </Link>
          <button
            data-testid="legal-back-btn"
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-2 text-sm text-white/65 hover:text-[#E9C76A] transition-colors"
          >
            <ArrowLeft size={16} weight="thin" /> Back to site
          </button>
        </div>
      </header>

      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28"
      >
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-12 bg-[#E9C76A]" />
          <span className="overline">{overline}</span>
        </div>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-6 text-xs text-white/40 tracking-wider uppercase">
            Last updated · {lastUpdated}
          </p>
        )}
        <div className="prose-legal mt-12">{children}</div>
      </motion.section>

      <footer className="border-t border-white/5 py-10 mt-16">
        <div className="max-w-3xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Lawfields Solicitors</div>
          <div className="flex flex-wrap gap-5">
            <Link to="/privacy" className="hover:text-[#E9C76A]">Privacy Policy</Link>
            <Link to="/complaints" className="hover:text-[#E9C76A]">Complaints Procedure</Link>
            <Link to="/terms" className="hover:text-[#E9C76A]">Terms of Use</Link>
            <Link to="/accessibility" className="hover:text-[#E9C76A]">Accessibility</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
